import { render, staticRenderFns } from "./version-upgrade.vue?vue&type=template&id=79ca9388&scoped=true"
import script from "./version-upgrade.vue?vue&type=script&lang=js"
export * from "./version-upgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca9388",
  null
  
)

export default component.exports